import { Routes } from '@angular/router';

import { NavGuard } from './navigation/navigation-guard.service';
import { FormDispatcherComponent } from './form-dispatcher/form-dispatcher.component';
import { FormApplicationStatusComponent } from './form-application-status/form-application-status.component';
import { FormCustomerInformationComponent } from './form-customer-information/form-customer-information.component';
import { FormDriverInformationComponent } from './form-driver-information/form-driver-information.component';
import { FormMotorCarrierInformationComponent } from './form-motor-carrier-information/form-motor-carrier-information.component';
import { FormReviewCoverageComponent } from './form-review-coverage/form-review-coverage.component';
import { FormVehiclesInformationComponent } from './form-vehicles-information/form-vehicles-information.component';
import { FormApplicationSummaryComponent } from './form-application-summary/form-application-summary.component';
import { CoverageFormResolverService } from './coverage-form-resolver.service';

export const FORM_ROUTES: Routes = [
  {
    path: 'customer-information',
    component: FormCustomerInformationComponent,
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: 'vehicles-information',
    component: FormVehiclesInformationComponent,
    canActivate: [NavGuard],
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: 'driver-information',
    component: FormDriverInformationComponent,
    canActivate: [NavGuard],
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: 'motor-carrier-information',
    component: FormMotorCarrierInformationComponent,
    canActivate: [NavGuard],
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: 'application-summary',
    canActivate: [NavGuard],
    component: FormApplicationSummaryComponent,
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: 'review-coverage',
    component: FormReviewCoverageComponent,
    canActivate: [NavGuard],
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: 'application-status',
    canActivate: [NavGuard],
    component: FormApplicationStatusComponent,
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: '',
    component: FormDispatcherComponent,
    resolve: { forms: CoverageFormResolverService }
  }, {
    path: '**',
    component: FormDispatcherComponent,
    resolve: { forms: CoverageFormResolverService }
  },
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/coverage-form.routes.ts